/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 14:44:23
 * @LastEditTime: 2020-11-21 18:25:02
 * @LastEditors: wutt
 */
import { POISearchLayer } from "./POISearchLayer.js";
import { RouteLayer } from "./RouteLayer.js";
import { MapBaseLayer, MapBaseLayerType } from "./MapBaseLayer.js";
import { DistrictLayer } from "./DistrictLayer.js";
import { OLLayerUtility } from "../../../../utility/common/OLLayerUtility.js";
import { BaseLayerConfig } from "../../../../config/BaseLayerConfig.js";
import { DrawGeometryLayer } from "./DrawGeometryLayer.js";
/**
 * 图层管理
 */
export class LayerManager {


    constructor() {
        this.currentMap = null;
        this.markerLayer = null;
        this.poiSearchLayer = new POISearchLayer();
        this.routeLayer = new RouteLayer();
        this.drawGeometryLayer=new DrawGeometryLayer();
        // this.mapServiceLayer = new MapServiceLayer();
        //底图
        this.baseLayer = null;

        this.districtLayer=new DistrictLayer();

        this.ucMapOverLay=null;

        //map地图，默认标记图层
        this.mapDefaultMarkerLayer=null;
    }


    /**
     * 初始化
     */
    init() {

        //获取map默认的marker图层
        let layers = this.currentMap.getMarkerLayers().getLayers().getArray();
        this.mapDefaultMarkerLayer = OLLayerUtility.findByLayerAttribute(layers,"name","marker_default");
        

        this.poiSearchLayer.curMap=this.currentMap;
        this.routeLayer.curMap=this.currentMap;
        this.drawGeometryLayer.curMap=this.currentMap;
        
        // this.mapServiceLayer.curMap = this.currentMap;
        this.baseLayer.curMap=this.currentMap;
        this.districtLayer.curMap=this.currentMap;
        

        //展示矢量图层
        this.baseLayer.showVisibleLayer(MapBaseLayerType.Vector);
    }



    /**
     * 初始化底图配置
     */
    initBaseLayerConfig() {

        let mapSrcURLs = new Array();
        let tempLayer =null;
        
        tempLayer =BaseLayerConfig.createAPITdtXYZVec_cLayer();//
        tempLayer.onAdd = function (map) {};


        mapSrcURLs.push(tempLayer);

        let mapAPI = new EzMapAPIES6();
        mapAPI.MapSrcURL = mapSrcURLs;
        mapAPI.CenterPoint =BaseLayerConfig.map_view_init_centerPoint;
        mapAPI.MapInitLevel =BaseLayerConfig.map_view_init_initLevel;
        mapAPI.MapMaxLevel =BaseLayerConfig.map_view_maxLevel;
        mapAPI.MapMinLevel =BaseLayerConfig.map_view_minLevel;
        
        EzMapAPIES6.instance = mapAPI;
    }
    /**
     * @Author: wutt
     * @Date: 2020-11-19 09:56:28
     * @Description: 根据运维管理配置初始化底图
     */
    initBaseLayerConfigEx(){
        let mapSrcURLs = new Array();
        let tempLayer = null;
        if (
          this.baseLayer.tdtServiceInfos &&
          this.baseLayer.tdtServiceInfos.length > 0
        ) {
          let tdtServiceInfos = this.baseLayer.tdtServiceInfos;
          let tdtServiceInfosObj = tdtServiceInfos.findByType(MapBaseLayerType.Vector);
          if (tdtServiceInfosObj.length > 0) {
              tempLayer = tdtServiceInfosObj[0].createAPITdtXYZVec_cLayer();
            tempLayer.onAdd = function (map) {};
            mapSrcURLs.push(tempLayer);
  
            let mapAPI = new EzMapAPIES6();
            mapAPI.MapSrcURL = mapSrcURLs;
            mapAPI.CenterPoint = BaseLayerConfig.map_view_init_centerPoint; // [103.840237,36.069102];
            mapAPI.MapInitLevel = BaseLayerConfig.map_view_init_initLevel; // 9;
            mapAPI.MapMaxLevel = BaseLayerConfig.map_view_maxLevel; // 20;
            mapAPI.MapMinLevel = BaseLayerConfig.map_view_minLevel; // 2;
  
            EzMapAPIES6.instance = mapAPI;
          }
        }
    }


    /**
     * 添加图层
     */
    addLayers() {
        this.markerLayer =this.mapDefaultMarkerLayer;// this._createMarkerLayer(null);

        POISearchLayer.markerLayer = this.markerLayer;
        DrawGeometryLayer.layer=this.markerLayer;

        RouteLayer.layer = this.markerLayer;

        // this.currentMap.addLayer(POISearchLayer.markerLayer);

        let layers = this.currentMap.getLayers();
        layers.insertAt(1, POISearchLayer.markerLayer);

        layers = this.currentMap.getLayers();
    }

    /**
     * 清除所有标记元素
     */
    clearMarkers() {
        if (this.markerLayer) {
            this.markerLayer.getSource().clear();
        }

        if(this.ucMapOverLay)
        {
            this.ucMapOverLay.clearOverlays();
        }

        this.currentMap.clearDragMode();
        if(this.mapDefaultMarkerLayer)
        {   
            this.mapDefaultMarkerLayer.getSource().clear();
        }
        
    }
    

    clearRouteLayer()
    {   
        if(this.ucMapOverLay)
        {
            this.ucMapOverLay.clearOverlays();
        }

        this.routeLayer.clear();
    }

    
    clearPOISearchLayer()
    {   
        this.poiSearchLayer.clear();
        if(this.ucMapOverLay)
        {
            this.ucMapOverLay.clearOverlays();
        }
    }

    /**
     * 创建标记点图层
     */
    _createMarkerLayer(onAddCallback) {

        let vectorSource = new ol.source.Vector({
            features: []
        });

        let vectorLayer = new ol.layer.Vector({
            name: 'markerlayer',
            source: vectorSource,
            visible: true,
            zIndex: 100
        });

        vectorLayer.onAdd = function (curentMap) {
            if (onAddCallback) {
                onAddCallback(curentMap);
            }
        }

        return vectorLayer;
    }

}   